// // import { useRef, useState } from "react";

// // const HP_C = {
// //   bg: "#F1E9FE", card: "#FFFAFB", border: "#E9DCFF",
// //   dark: "#4000BC", mid: "#9D4DFF", light: "#C69FF4",
// //   textDark: "#330C5F", textMid: "#40008C", textLight: "#9D4DFF",
// // };

// // const HP_PLANS = [
// //   {
// //     id: 2, tier: "01", title: "Standard", tag: "Includes cake, lights & decor.", badge: "Save ₹200",
// //     g: ["#7B2FE0", "#C69FF4"], buttonText: "Proceed →",
// //     f: {
// //       "Theatre + Decoration": 1, "Fog Entry (1 Pot)": 1, "Candle Path": 1,
// //       "HBD LED": 1, "Name with LED (6)": 1, "AGE Number LED": 1,
// //       "HBD with Rose Petals": 1, "Photo Clipping (10)": 1, "Birthday Sash": 1,
// //       "Birthday Crown, Spects": 1, "Rose": 1, "Regular Cake – ½ kg": 1,
// //       "Photography (15 Mins)": 1, "Cold Fire Entry (6 pcs)": 0,
// //       "Videography (1-Min Reel)": 0, "Hall Fog (4 Pots)": 0,
// //     },
// //   },
// //   {
// //     id: 3, tier: "02", title: "Special", tag: "Our grandest experience, full royal vibes.", badge: "★ Most Popular", star: 1,
// //     g: [HP_C.mid, HP_C.light], buttonText: "Proceed →",
// //     f: {
// //       "Theatre + Decoration": 1, "Fog Entry (1 Pot)": 1, "Candle Path": 1,
// //       "HBD LED": 1, "Name with LED (6)": 1, "AGE Number LED": 1,
// //       "HBD with Rose Petals": 1, "Photo Clipping (10)": 1, "Birthday Sash": 1,
// //       "Birthday Crown, Spects": 1, "Rose Bouquet (6 Roses)": 1,
// //       "Customisation Cake (1 kg)": 1, "Photography (30 Mins)": 1,
// //       "Cold Fire Entry (4 pcs)": 1, "Videography (1-Min Reel)": 0, "Hall Fog (4 Pots)": 0,
// //     },
// //   },
// //   {
// //     id: 4, tier: "03", title: "Premium", tag: "More guests, more upgrades, more glam.", badge: "Save ₹300",
// //     g: ["#5B21B6", HP_C.light], buttonText: "Proceed →",
// //     f: {
// //       "Theatre + Decoration": 1, "Fog Entry (1 Pot)": 1, "Candle Path": 1,
// //       "HBD LED": 1, "Name with LED (6)": 1, "AGE Number LED": 1,
// //       "HBD with Rose Petals": 1, "Photo Clipping (10)": 1, "Birthday Sash": 1,
// //       "Birthday Crown, Spects": 1, "Rose Bouquet (12 Roses)": 1,
// //       "Customisation Cake (1 kg)": 1, "Photography (30 Mins)": 1,
// //       "Cold Fire Entry (6 pcs)": 1, "Videography (1-Min Reel)": 1, "Hall Fog (4 Pots)": 1,
// //     },
// //   },
// // ];

// // const HP_PREVIEW = 7;
// // const HP_CARD_VW = 68, HP_GAP_VW = 4;

// // const BODY_FONT = "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif";
// // const HEAD_FONT = "Georgia, 'Times New Roman', Times, serif";

// // const hpCss = `
// // .hp-cc, .hp-cc * { box-sizing:border-box; margin:0; padding:0; }
// // .hp-cc {
// //   font-family: ${BODY_FONT};
// //   background:${HP_C.bg};
// //   position:relative; overflow:hidden;
// // }
// // .hp-cc::before,.hp-cc::after {
// //   content:''; position:absolute; border-radius:50%;
// //   pointer-events:none; filter:blur(90px); opacity:.28;
// // }
// // .hp-cc::before { width:540px;height:540px; background:radial-gradient(circle,${HP_C.light},transparent 70%); top:-160px;right:-120px; }
// // .hp-cc::after  { width:360px;height:360px; background:radial-gradient(circle,${HP_C.border},transparent 70%); bottom:-80px;left:-80px; }

// // /* heading */
// // .hp-head { text-align:center; margin-bottom:0; position:relative; z-index:2; animation:hp-fadeUp .65s ease both; }
// // @keyframes hp-fadeUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:none} }
// // .hp-eyebrow {
// //   display:inline-flex; align-items:center; gap:7px;
// //   font-size:10px; font-weight:600; letter-spacing:3px; text-transform:uppercase;
// //   color:${HP_C.textLight}; background:${HP_C.card}; border:1px solid ${HP_C.border};
// //   padding:5px 16px; border-radius:999px; margin-bottom:16px;
// //   box-shadow:0 2px 12px rgba(157,77,255,.1);
// //   font-family: ${BODY_FONT};
// // }
// // .hp-eyebrow::before,.hp-eyebrow::after{content:'✦';font-size:8px;opacity:.55}
// // .hp-title {
// //   font-family: ${HEAD_FONT};
// //   font-size:clamp(34px,5vw,54px); font-weight:700;
// //   color:${HP_C.textDark}; line-height:1.1; margin-bottom:8px; letter-spacing:-.2px;
// // }
// // .hp-title em {
// //   font-style:italic;
// //   background:linear-gradient(135deg,${HP_C.textMid},${HP_C.mid});
// //   -webkit-background-clip:text; -webkit-text-fill-color:transparent;
// // }
// // .hp-sub { color:${HP_C.light}; font-size:13.5px; font-family: ${BODY_FONT}; }
// // .hp-rule { display:flex; align-items:center; justify-content:center; gap:10px; margin-top:16px; }
// // .hp-rl  { width:44px;height:1px; background:linear-gradient(to right,transparent,${HP_C.light}); }
// // .hp-rl.r{ background:linear-gradient(to left,transparent,${HP_C.light}); }
// // .hp-rd  { width:6px;height:6px; background:${HP_C.mid}; transform:rotate(45deg); border-radius:1px; }

// // /* desktop track */
// // .hp-track {
// //   display:flex; align-items:center; justify-content:center;
// //   padding:28px 0 36px; position:relative; z-index:2;
// // }
// // .hp-slot {
// //   flex-shrink:0; cursor:pointer;
// //   transition:transform .5s cubic-bezier(.34,1.5,.64,1),opacity .5s ease,filter .5s ease,margin .5s cubic-bezier(.34,1.5,.64,1);
// //   animation:hp-fadeUp .6s ease both;
// // }
// // .hp-slot:nth-child(1){animation-delay:.1s}
// // .hp-slot:nth-child(2){animation-delay:.2s}
// // .hp-slot:nth-child(3){animation-delay:.3s}
// // .hp-slot.center { width:340px; transform:scale(1) translateY(0); z-index:10; }
// // .hp-slot.side   { width:272px; transform:scale(0.82) translateY(28px); opacity:.55; filter:saturate(.65); z-index:5; margin:0 -28px; }
// // .hp-slot.side:hover { opacity:.78; transform:scale(0.86) translateY(20px); filter:saturate(.85); }

// // /* card */
// // .hp-card {
// //   background:${HP_C.card}; border-radius:22px; overflow:hidden;
// //   border:1.5px solid transparent; display:flex; flex-direction:column; position:relative;
// //   transition:border-color .35s,box-shadow .35s;
// // }
// // .hp-slot.center .hp-card {
// //   border-color:${HP_C.border};
// //   box-shadow:0 0 0 4px rgba(157,77,255,.07),0 22px 56px rgba(64,0,188,.12),0 6px 16px rgba(157,77,255,.09);
// // }
// // .hp-slot.side .hp-card { box-shadow:0 4px 18px rgba(64,0,188,.06); }

// // .hp-stripe { height:4px; background:var(--g); }
// // .hp-tier {
// //   position:absolute; top:14px; right:16px;
// //   font-family: ${HEAD_FONT};
// //   font-size:48px; font-weight:700;
// //   line-height:1; color:rgba(198,159,244,.18); pointer-events:none; user-select:none; transition:color .35s;
// // }
// // .hp-slot.center .hp-tier { color:rgba(157,77,255,.1); }
// // .hp-body { padding:26px 22px 24px; flex:1; display:flex; flex-direction:column; }

// // .hp-badge {
// //   display:inline-flex; align-items:center; gap:4px;
// //   font-size:9.5px; font-weight:700; letter-spacing:1px; text-transform:uppercase;
// //   padding:3px 10px; border-radius:999px; margin-bottom:10px; width:fit-content;
// //   background:${HP_C.bg}; border:1px solid ${HP_C.border}; color:${HP_C.textLight};
// //   transition:background .35s,color .35s,box-shadow .35s;
// //   font-family: ${BODY_FONT};
// // }
// // .hp-slot.center .hp-badge { background:var(--g); border:none; color:#fff; box-shadow:0 3px 12px rgba(157,77,255,.28); }

// // .hp-name {
// //   font-family: ${HEAD_FONT};
// //   font-size:24px; font-weight:700; color:${HP_C.textDark}; margin-bottom:2px; letter-spacing:-.1px;
// // }
// // .hp-tag  { font-size:12px; color:${HP_C.light}; margin-bottom:13px; font-family: ${BODY_FONT}; }
// // .hp-div  { height:1px; background:linear-gradient(to right,${HP_C.border},transparent); margin-bottom:11px; }

// // .hp-feats { list-style:none; flex:1; }
// // .hp-feat  {
// //   display:flex; align-items:center; gap:8px;
// //   padding:7px 0; border-bottom:1px solid rgba(198,159,244,.1); font-size:12.5px;
// //   font-family: ${BODY_FONT};
// // }
// // .hp-feat.y { color:${HP_C.textDark}; }
// // .hp-feat.n { color:${HP_C.light}; opacity:.58; }
// // .hp-feat.n span:last-child { text-decoration:line-through; }
// // .hp-dot {
// //   width:18px;height:18px;border-radius:50%;flex-shrink:0;
// //   display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:800;
// // }
// // .hp-dot.y{background:#F0FDF4;color:#15803D} .hp-dot.n{background:#FDF4FF;color:${HP_C.light}}

// // .hp-more {
// //   background:none;border:none;color:${HP_C.textLight};font-size:11.5px;font-weight:600;
// //   cursor:pointer;padding:7px 0 2px;
// //   font-family: ${BODY_FONT};
// //   transition:color .2s;
// // }
// // .hp-more:hover{color:${HP_C.textMid}}

// // .hp-btn {
// //   width:100%;border:none;border-radius:12px;padding:11.5px 16px;
// //   font-family: ${BODY_FONT};
// //   font-weight:600;font-size:13.5px;cursor:pointer;
// //   display:flex;align-items:center;justify-content:center;gap:6px;margin-top:15px;
// //   transition:transform .18s,box-shadow .18s,background .35s;
// // }
// // .hp-slot.center .hp-btn,.hp-btn.active {
// //   background:var(--g);color:#fff;box-shadow:0 5px 20px rgba(157,77,255,.36);
// // }
// // .hp-slot.center .hp-btn:hover{transform:translateY(-2px);box-shadow:0 8px 28px rgba(157,77,255,.46)}
// // .hp-slot.side .hp-btn,.hp-btn.passive {
// //   background:${HP_C.bg};color:${HP_C.textMid};border:1.5px solid ${HP_C.border};
// // }
// // .hp-slot.side .hp-btn:hover,.hp-btn.passive:hover{background:${HP_C.border}}

// // /* dots */
// // .hp-dots { display:flex;justify-content:center;gap:7px;margin-top:6px;position:relative;z-index:2; }
// // .hp-pip  { border:none;padding:0;cursor:pointer;height:7px;border-radius:999px;background:${HP_C.border};transition:all .32s ease; }
// // .hp-pip.on{ background:linear-gradient(90deg,${HP_C.textMid},${HP_C.mid}); }

// // /* mobile */
// // .hp-mob { overflow:hidden;padding:16px 0 20px;position:relative;z-index:2; }
// // .hp-mob-track {
// //   display:flex;align-items:flex-start;
// //   transition:transform .46s cubic-bezier(.34,1.26,.64,1);
// //   will-change:transform;
// // }
// // .hp-mob-slide {
// //   flex-shrink:0;cursor:pointer;
// //   transition:transform .44s ease,opacity .44s ease,filter .44s ease;
// // }
// // .hp-mob-slide.mc{transform:scale(1);opacity:1;filter:none}
// // .hp-mob-slide.ms{transform:scale(0.87) translateY(14px);opacity:.5;filter:saturate(.65)}

// // .hp-nav { display:flex;justify-content:center;gap:10px;margin-top:14px; }
// // .hp-nav-btn {
// //   border-radius:12px;padding:8px 22px;font-weight:600;font-size:13px;
// //   cursor:pointer;
// //   font-family: ${BODY_FONT};
// //   transition:all .2s;border:none;
// // }
// // .hp-nav-btn.p { background:${HP_C.card};border:1.5px solid ${HP_C.border};color:${HP_C.textMid};box-shadow:0 2px 8px rgba(157,77,255,.08); }
// // .hp-nav-btn.p:hover:not(:disabled){background:${HP_C.bg}}
// // .hp-nav-btn.n { background:linear-gradient(135deg,${HP_C.textMid},${HP_C.mid});color:#fff;box-shadow:0 4px 14px rgba(157,77,255,.32); }
// // .hp-nav-btn.n:hover:not(:disabled){box-shadow:0 6px 20px rgba(157,77,255,.44)}
// // .hp-nav-btn:disabled{opacity:.25;cursor:not-allowed}

// // @media(max-width:767px){.hp-cc{padding:48px 0 60px}.hp-head{margin-bottom:36px}}
// // `;

// // function HpCard({ p, mobRole, onBook }) {
// //   const [exp, setExp] = useState(false);
// //   const feats = Object.entries(p.f);
// //   const shown = exp ? feats : feats.slice(0, HP_PREVIEW);
// //   const grad = `linear-gradient(135deg,${p.g[0]},${p.g[1]})`;
// //   const isM = mobRole != null;

// //   return (
// //     <div className="hp-card" style={{ "--g": grad }}>
// //       <div className="hp-stripe" />
// //       <div className="hp-tier">{p.tier}</div>
// //       <div className="hp-body">
// //         <span className="hp-badge">{p.badge}</span>
// //         <h5 className="hp-name">{p.title}</h5>
// //         <p className="hp-tag">{p.tag}</p>
// //         <div className="hp-div" />
// //         <ul className="hp-feats">
// //           {shown.map(([k, v], i) => (
// //             <li key={i} className={`hp-feat ${v ? "y" : "n"}`}>
// //               <span className={`hp-dot ${v ? "y" : "n"}`}>{v ? "✓" : "·"}</span>
// //               <span>{k}</span>
// //             </li>
// //           ))}
// //         </ul>
// //         {feats.length > HP_PREVIEW && (
// //           <button className="hp-more" onClick={e => { e.stopPropagation(); setExp(x => !x); }}>
// //             {exp ? "▲ Show less" : `▼ All ${feats.length} inclusions`}
// //           </button>
// //         )}
// //         <button
// //           className={`hp-btn${isM ? (mobRole === "c" ? " active" : " passive") : ""}`}
// //           style={{ "--g": grad }}
// //           onClick={e => { e.stopPropagation(); onBook(); }}
// //         >
// //           {p.buttonText}
// //         </button>
// //       </div>
// //     </div>
// //   );
// // }

// // function HomePackagesSection({ navigateTheater }) {
// //   const [active, setActive] = useState(1);
// //   const mobX = `calc(${50 - HP_CARD_VW / 2}vw - ${active * (HP_CARD_VW + HP_GAP_VW)}vw)`;

// //   const touchStartX = useRef(null);
// //   const touchStartY = useRef(null);
// //   const isSwiping = useRef(false);

// //   const onTouchStart = e => {
// //     touchStartX.current = e.touches[0].clientX;
// //     touchStartY.current = e.touches[0].clientY;
// //     isSwiping.current = false;
// //   };
// //   const onTouchMove = e => {
// //     if (!touchStartX.current) return;
// //     const dx = Math.abs(e.touches[0].clientX - touchStartX.current);
// //     const dy = Math.abs(e.touches[0].clientY - touchStartY.current);
// //     if (dx > dy && dx > 8) { isSwiping.current = true; e.preventDefault(); }
// //   };
// //   const onTouchEnd = e => {
// //     if (!touchStartX.current) return;
// //     const dx = e.changedTouches[0].clientX - touchStartX.current;
// //     if (isSwiping.current && Math.abs(dx) > 40)
// //       setActive(p => dx < 0 ? Math.min(HP_PLANS.length - 1, p + 1) : Math.max(0, p - 1));
// //     touchStartX.current = null;
// //     isSwiping.current = false;
// //   };

// //   const Dots = () => (
// //     <div className="hp-dots">
// //       {HP_PLANS.map((_, i) => (
// //         <button key={i} className={`hp-pip${i === active ? " on" : ""}`}
// //           style={{ width: i === active ? "26px" : "7px" }} onClick={() => setActive(i)} />
// //       ))}
// //     </div>
// //   );

// //   return (
// //     <section className="hp-cc py-5">
// //       <style>{hpCss}</style>

// //       {/* Heading */}
// //       <div className="hp-head">
// //         <div className="hp-eyebrow">Celebration Packages</div>
// //         <h2 className="hp-title">Choose Your <em>Celebration</em></h2>
// //         <p className="hp-sub">Pick the plan that matches your moment</p>
// //         <div className="hp-rule">
// //           <div className="hp-rl" /><div className="hp-rd" /><div className="hp-rl r" />
// //         </div>
// //       </div>

// //       {/* Desktop */}
// //       <div className="d-none d-md-block">
// //         <div className="hp-track">
// //           {HP_PLANS.map((p, i) => (
// //             <div key={p.id} className={`hp-slot ${i === active ? "center" : "side"}`} onClick={() => setActive(i)}>
// //               <HpCard p={p} onBook={() => navigateTheater("/locations")} />
// //             </div>
// //           ))}
// //         </div>
// //         <Dots />
// //       </div>

// //       {/* Mobile */}
// //       <div className="d-md-none hp-mob"
// //         onTouchStart={onTouchStart}
// //         onTouchMove={onTouchMove}
// //         onTouchEnd={onTouchEnd}
// //       >
// //         <div className="hp-mob-track" style={{ transform: `translateX(${mobX})` }}>
// //           {HP_PLANS.map((p, i) => (
// //             <div key={p.id}
// //               className={`hp-mob-slide ${i === active ? "mc" : "ms"}`}
// //               style={{ width: `${HP_CARD_VW}vw`, marginLeft: i === 0 ? 0 : `${HP_GAP_VW}vw` }}
// //               onClick={() => { if (!isSwiping.current) setActive(i); }}
// //             >
// //               <HpCard p={p} mobRole={i === active ? "c" : "s"} onBook={() => navigateTheater("/locations")} />
// //             </div>
// //           ))}
// //         </div>
// //         <Dots />
// //         <div className="hp-nav">
// //           <button className="hp-nav-btn p" disabled={active === 0} onClick={() => setActive(p => p - 1)}>← Prev</button>
// //           <button className="hp-nav-btn n" disabled={active === HP_PLANS.length - 1} onClick={() => setActive(p => p + 1)}>Next →</button>
// //         </div>
// //       </div>

// //       {/* WhatsApp Chat Button */}
// //       <div style={{ textAlign: "center", marginTop: "30px" }}>
// //         <a
// //           href="https://wa.me/918374777834?text=Hello%2C%20I%20want%20to%20book%20tickets."
// //           target="_blank"
// //           rel="noopener noreferrer"
// //           style={{
// //             display: "inline-flex",
// //             alignItems: "center",
// //             gap: "8px",
// //             padding: "14px 28px",
// //             borderRadius: "50px",
// //             fontWeight: "600",
// //             fontSize: "14px",
// //             fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
// //             background: "#25D366",
// //             color: "#fff",
// //             textDecoration: "none",
// //             boxShadow: "0 6px 18px rgba(37,211,102,0.35)",
// //             transition: "all 0.3s ease",
// //           }}
// //           onMouseEnter={e => {
// //             e.currentTarget.style.transform = "translateY(-2px)";
// //             e.currentTarget.style.boxShadow = "0 10px 24px rgba(37,211,102,0.45)";
// //           }}
// //           onMouseLeave={e => {
// //             e.currentTarget.style.transform = "translateY(0)";
// //             e.currentTarget.style.boxShadow = "0 6px 18px rgba(37,211,102,0.35)";
// //           }}
// //         >
// //           <i className="bi bi-whatsapp"></i>
// //           Chat With Us
// //         </a>
// //       </div>
// //     </section>
// //   );
// // }

// // export default HomePackagesSection;

// import { useRef, useState, useEffect } from "react";

// const PLANS = [
//   {
//     id: 0, tier: "01", title: "Standard",
//     tagline: "Includes cake, lights & decor. A warm, intimate celebration.",
//     save: "💰 Save ₹200", featured: false,
//     features: [
//       { label: "Theatre + Decoration",      yes: true  },
//       { label: "Fog Entry (1 Pot)",          yes: true  },
//       { label: "Candle Path",                yes: true  },
//       { label: "HBD LED + Name LED (6)",     yes: true  },
//       { label: "AGE Number LED",             yes: true  },
//       { label: "HBD with Rose Petals",       yes: true  },
//       { label: "Photo Clipping (10)",        yes: true  },
//       { label: "Birthday Sash",              yes: true  },
//       { label: "Birthday Crown & Specs",     yes: true  },
//       { label: "Rose",                       yes: true  },
//       { label: "Regular Cake – ½ kg",        yes: true  },
//       { label: "Photography (15 Mins)",      yes: true  },
//       { label: "Cold Fire Entry",            yes: false },
//       { label: "Videography (1-Min Reel)",   yes: false },
//       { label: "Hall Fog (4 Pots)",          yes: false },
//     ],
//   },
//   {
//     id: 1, tier: "02", title: "Special",
//     tagline: "Royal vibes — custom cake, cold fire & extended photography.",
//     save: "⭐ Guests' Favourite", featured: true,
//     features: [
//       { label: "Theatre + Decoration",      yes: true  },
//       { label: "Fog Entry (1 Pot)",          yes: true  },
//       { label: "Candle Path",                yes: true  },
//       { label: "HBD LED + Name LED (6)",     yes: true  },
//       { label: "AGE Number LED",             yes: true  },
//       { label: "HBD with Rose Petals",       yes: true  },
//       { label: "Photo Clipping (10)",        yes: true  },
//       { label: "Birthday Sash + Crown",      yes: true  },
//       { label: "Rose Bouquet (6 Roses)",     yes: true  },
//       { label: "Customisation Cake (1 kg)",  yes: true  },
//       { label: "Photography (30 Mins)",      yes: true  },
//       { label: "Cold Fire Entry (4 pcs)",    yes: true  },
//       { label: "Videography (1-Min Reel)",   yes: false },
//       { label: "Hall Fog (4 Pots)",          yes: false },
//     ],
//   },
//   {
//     id: 2, tier: "03", title: "Premium",
//     tagline: "The complete experience — everything included, zero compromises.",
//     save: "🎁 Save ₹300", featured: false,
//     features: [
//       { label: "Theatre + Decoration",      yes: true },
//       { label: "Fog Entry + Hall Fog",       yes: true },
//       { label: "Candle Path",                yes: true },
//       { label: "HBD LED + Name LED (6)",     yes: true },
//       { label: "AGE Number LED",             yes: true },
//       { label: "HBD with Rose Petals",       yes: true },
//       { label: "Photo Clipping (10)",        yes: true },
//       { label: "Birthday Sash + Crown",      yes: true },
//       { label: "Rose Bouquet (12 Roses)",    yes: true },
//       { label: "Customisation Cake (1 kg)",  yes: true },
//       { label: "Photography (30 Mins)",      yes: true },
//       { label: "Cold Fire Entry (6 pcs)",    yes: true },
//       { label: "Videography (1-Min Reel)",   yes: true },
//       { label: "Hall Fog (4 Pots)",          yes: true },
//     ],
//   },
// ];

// const PREVIEW = 7;

// function HpsPlanCard({ plan, onBook }) {
//   const [expanded, setExpanded] = useState(false);
//   const shown = expanded ? plan.features : plan.features.slice(0, PREVIEW);

//   return (
//     <div className={`hps-card${plan.featured ? " hps-card-feat" : ""}`}>
//       {plan.featured && <div className="hps-topline" />}
//       {plan.featured && <div className="hps-crown">✦ Most Popular ✦</div>}

//       <div className="hps-inner">
//         <div className="hps-tier">{plan.tier} &nbsp; {plan.title}</div>
//         <div className={`hps-name${plan.featured ? " hps-name-feat" : ""}`}>{plan.title}</div>
//         <p className="hps-tagline">{plan.tagline}</p>
//         <div className={`hps-save${plan.featured ? " hps-save-feat" : ""}`}>{plan.save}</div>
//         <div className={`hps-hdiv${plan.featured ? " hps-hdiv-feat" : ""}`} />

//         <div className="hps-feats">
//           {shown.map((f, i) => (
//             <div key={i} className={`hps-frow${f.yes ? " hps-fy" : " hps-fn"}`}>
//               <div className={f.yes ? "hps-dy" : "hps-dn"}>{f.yes ? "✓" : "—"}</div>
//               <span className="hps-fl">{f.label}</span>
//             </div>
//           ))}
//         </div>

//         {plan.features.length > PREVIEW && (
//           <button
//             className="hps-expand"
//             style={plan.featured ? { color: "rgba(201,168,76,.65)" } : {}}
//             onClick={() => setExpanded(e => !e)}
//           >
//             {expanded ? "▴ Show less" : "▾ All inclusions"}
//           </button>
//         )}
//       </div>

//       <div className="hps-cta">
//         <button
//           className={`hps-btn${plan.featured ? " hps-btn-gold" : " hps-btn-outline"}`}
//           onClick={onBook}
//         >
//           {plan.featured && <span className="hps-shine" />}
//           {plan.featured ? "Book This Plan →" : "Proceed to Book →"}
//         </button>
//       </div>
//     </div>
//   );
// }

// function HomePackagesSection({ navigateTheater }) {
//   const [active, setActive] = useState(1);
//   const touchStartX = useRef(null);
//   const touchStartY = useRef(null);
//   const isSwiping   = useRef(false);

//   const onTouchStart = e => {
//     touchStartX.current = e.touches[0].clientX;
//     touchStartY.current = e.touches[0].clientY;
//     isSwiping.current   = false;
//   };
//   const onTouchMove = e => {
//     if (!touchStartX.current) return;
//     const dx = Math.abs(e.touches[0].clientX - touchStartX.current);
//     const dy = Math.abs(e.touches[0].clientY - touchStartY.current);
//     if (dx > dy && dx > 8) { isSwiping.current = true; e.preventDefault(); }
//   };
//   const onTouchEnd = e => {
//     if (!touchStartX.current) return;
//     const dx = e.changedTouches[0].clientX - touchStartX.current;
//     if (isSwiping.current && Math.abs(dx) > 40)
//       setActive(p => dx < 0 ? Math.min(PLANS.length - 1, p + 1) : Math.max(0, p - 1));
//     touchStartX.current = null;
//     isSwiping.current   = false;
//   };

//   const CARD_VW = 78, GAP_VW = 4;
//   const mobX = `calc(${50 - CARD_VW / 2}vw - ${active * (CARD_VW + GAP_VW)}vw)`;

//   const HpsDots = () => (
//     <div className="hps-dots">
//       {PLANS.map((_, i) => (
//         <button
//           key={i}
//           className={`hps-pip${i === active ? " hps-pip-on" : ""}`}
//           style={{ width: i === active ? 28 : 8 }}
//           onClick={() => setActive(i)}
//         />
//       ))}
//     </div>
//   );

//   return (
//     <section className="hps-sec">
//       <div className="hps-noise" />
//       <HpsParticles />

//       <div className="container">
//         <div className="hps-hdr rv">
//           <div className="hps-pre">Celebration Packages</div>
//           <h2 className="hps-title">Choose Your <em>Plans</em></h2>
//           <p className="hps-subtitle">
//             Every package includes full private theatre access — crafted for unforgettable moments
//           </p>
//         </div>

//         {/* desktop */}
//         <div className="hps-grid d-none d-md-grid rv">
//           {PLANS.map(p => (
//             <HpsPlanCard key={p.id} plan={p} onBook={() => navigateTheater("/locations")} />
//           ))}
//         </div>
//         <div className="d-none d-md-flex" style={{ justifyContent: "center" }}>
//           <HpsDots />
//         </div>

//         {/* mobile */}
//         <div
//           className="hps-mob d-md-none"
//           onTouchStart={onTouchStart}
//           onTouchMove={onTouchMove}
//           onTouchEnd={onTouchEnd}
//         >
//           <div className="hps-mob-track" style={{ transform: `translateX(${mobX})` }}>
//             {PLANS.map((p, i) => (
//               <div
//                 key={p.id}
//                 className={`hps-mob-slide${i === active ? " hps-mc" : " hps-ms"}`}
//                 style={{ width: `${CARD_VW}vw`, marginLeft: i === 0 ? 0 : `${GAP_VW}vw` }}
//                 onClick={() => { if (!isSwiping.current) setActive(i); }}
//               >
//                 <HpsPlanCard plan={p} onBook={() => navigateTheater("/locations")} />
//               </div>
//             ))}
//           </div>
//           <HpsDots />
//           <div className="hps-mob-nav">
//             <button className="hps-nav-p" disabled={active === 0} onClick={() => setActive(p => p - 1)}>← Prev</button>
//             <button className="hps-nav-n" disabled={active === PLANS.length - 1} onClick={() => setActive(p => p + 1)}>Next →</button>
//           </div>
//         </div>

//         {/* whatsapp */}
//         <div style={{ textAlign: "center", marginTop: 32, position: "relative", zIndex: 2 }}>
//           <a
//             href="https://wa.me/918374777834?text=Hello%2C%20I%20want%20to%20book%20tickets."
//             target="_blank" rel="noopener noreferrer"
//             className="hps-wa"
//           >
//             <i className="bi bi-whatsapp" /> Chat With Us
//           </a>
//         </div>
//       </div>

//       <HpsEntranceObserver />

//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,600;0,700;1,600&family=DM+Sans:wght@300;400;500;600&display=swap');

//         /* ── section ── */
//         .hps-sec {
//           padding: 96px 0 80px;
//           background: linear-gradient(170deg,#0D0020 0%,#180038 35%,#2A0055 65%,#0D0020 100%);
//           position: relative; overflow: hidden;
//         }
//         .hps-sec::before {
//           content: ''; position: absolute; inset: 0;
//           background:
//             radial-gradient(ellipse 800px 600px at 15% 20%,rgba(201,168,76,.05) 0%,transparent 60%),
//             radial-gradient(ellipse 600px 500px at 85% 80%,rgba(157,77,255,.08) 0%,transparent 60%);
//           pointer-events: none;
//         }
//         .hps-noise {
//           position: absolute; inset: 0; opacity: .02;
//           background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
//           pointer-events: none; z-index: 0;
//         }
//         .hps-particles { position: absolute; inset: 0; pointer-events: none; overflow: hidden; z-index: 1; }
//         .hps-p {
//           position: absolute; border-radius: 50%; background: #C9A84C;
//           animation: hps-float linear infinite; opacity: 0;
//         }
//         @keyframes hps-float {
//           0%   { transform: translateY(0) scale(0);       opacity: 0; }
//           10%  { opacity: .55; }
//           90%  { opacity: .25; }
//           100% { transform: translateY(-110px) scale(.4); opacity: 0; }
//         }

//         /* ── heading ── */
//         .hps-hdr { text-align: center; margin-bottom: 72px; position: relative; z-index: 2; }
//         .hps-pre {
//           display: inline-flex; align-items: center; gap: 10px;
//           font-size: 10px; font-weight: 600; letter-spacing: 4px; text-transform: uppercase;
//           color: #C9A84C; margin-bottom: 20px;
//         }
//         .hps-pre::before, .hps-pre::after {
//           content: ''; width: 32px; height: 1px;
//           background: linear-gradient(90deg, transparent, #C9A84C);
//         }
//         .hps-pre::after { background: linear-gradient(90deg, #C9A84C, transparent); }
//         .hps-title {
//           font-family: 'Cormorant Garamond', serif;
//           font-size: clamp(40px,6vw,68px); font-weight: 600;
//           color: #fff; line-height: 1.05; margin-bottom: 14px; letter-spacing: -.5px;
//         }
//         .hps-title em { font-style: italic; color: #C9A84C; }
//         .hps-subtitle { color: rgba(255,255,255,.38); font-size: 15px; font-weight: 300; }

//         /* ── grid ── */
//         .hps-grid {
//           display: grid;
//           grid-template-columns: 1fr 1.08fr 1fr;
//           gap: 0; position: relative; z-index: 2;
//           align-items: end; margin-bottom: 8px;
//         }

//         /* ── card base ── */
//         .hps-card {
//           position: relative;
//           background: linear-gradient(170deg,rgba(255,255,255,.045) 0%,rgba(255,255,255,.018) 100%);
//           border: 1px solid rgba(255,255,255,.09);
//           display: flex; flex-direction: column;
//           transition: transform .5s cubic-bezier(.25,1,.5,1), box-shadow .5s, opacity .7s;
//           cursor: pointer; overflow: hidden;
//           opacity: 0; transform: translateY(28px);
//         }
//         .hps-card.hps-visible { opacity: 1 !important; transform: translateY(0) !important; }
//         .hps-card:first-child { border-radius: 24px 0 0 24px; border-right: none; }
//         .hps-card:last-child  { border-radius: 0 24px 24px 0; border-left: none; }
//         .hps-card:hover { transform: translateY(-8px) !important; z-index: 3; }
//         .hps-card::before {
//           content: ''; position: absolute; inset: 0;
//           background: linear-gradient(170deg,rgba(201,168,76,.04) 0%,transparent 60%);
//           opacity: 0; transition: opacity .4s; pointer-events: none;
//         }
//         .hps-card:hover::before { opacity: 1; }

//         /* ── featured ── */
//         .hps-card-feat {
//           background: linear-gradient(170deg,rgba(201,168,76,.1) 0%,rgba(157,77,255,.06) 50%,rgba(201,168,76,.04) 100%) !important;
//           border: 1px solid rgba(201,168,76,.32) !important;
//           border-radius: 24px !important;
//           box-shadow:
//             0 0 0 1px rgba(201,168,76,.15),
//             0 32px 80px rgba(0,0,0,.6),
//             0 0 100px rgba(201,168,76,.07),
//             inset 0 1px 0 rgba(201,168,76,.2) !important;
//           z-index: 4;
//         }
//         .hps-card-feat.hps-visible { transform: translateY(-20px) scale(1.01) !important; }
//         .hps-card-feat:hover        { transform: translateY(-28px) scale(1.01) !important; }

//         /* topline */
//         .hps-topline {
//           position: absolute; top: 0; left: 0; right: 0; height: 2px;
//           background: linear-gradient(90deg,transparent,#C9A84C 30%,#F5D87A 50%,#C9A84C 70%,transparent);
//           animation: hps-topline 3s ease infinite; z-index: 5;
//         }
//         @keyframes hps-topline { 0%,100%{opacity:.65;} 50%{opacity:1;} }

//         /* crown */
//         .hps-crown {
//           position: absolute; top: -16px; left: 50%; transform: translateX(-50%);
//           background: linear-gradient(135deg,#B8860B,#C9A84C,#F5D87A,#C9A84C,#9A6E10);
//           background-size: 200% 200%;
//           animation: hps-gold 3s ease infinite;
//           color: #0D0020; font-size: 9px; font-weight: 800;
//           letter-spacing: 2px; text-transform: uppercase;
//           padding: 6px 20px; border-radius: 999px; white-space: nowrap; z-index: 10;
//           box-shadow: 0 4px 20px rgba(201,168,76,.5), 0 0 36px rgba(201,168,76,.12);
//         }
//         @keyframes hps-gold {
//           0%  { background-position: 0% 50%; }
//           50% { background-position: 100% 50%; }
//           100%{ background-position: 0% 50%; }
//         }

//         /* inner */
//         .hps-inner { padding: 36px 28px 20px; }
//         .hps-card-feat .hps-inner { padding: 44px 32px 20px; }

//         /* tier label */
//         .hps-tier {
//           font-family: 'Cormorant Garamond', serif;
//           font-size: 11px; font-weight: 600; letter-spacing: 4px; text-transform: uppercase;
//           color: rgba(201,168,76,.45); margin-bottom: 14px;
//           display: flex; align-items: center; gap: 8px;
//         }
//         .hps-tier::after { content: ''; flex: 1; height: 1px; background: linear-gradient(90deg,rgba(201,168,76,.15),transparent); }
//         .hps-card-feat .hps-tier { color: rgba(201,168,76,.72); }

//         /* plan name */
//         .hps-name {
//           font-family: 'Cormorant Garamond', serif;
//           font-size: clamp(28px,3.5vw,42px); font-weight: 600;
//           color: #fff; line-height: 1; margin-bottom: 6px;
//         }
//         .hps-name-feat { color: #F5D87A !important; }

//         /* tagline */
//         .hps-tagline { font-size: 12px; color: rgba(255,255,255,.32); line-height: 1.6; margin-bottom: 18px; font-weight: 300; }

//         /* save badge */
//         .hps-save {
//           display: inline-flex; align-items: center; gap: 5px;
//           background: rgba(201,168,76,.09); border: 1px solid rgba(201,168,76,.2);
//           color: #C9A84C; font-size: 10px; font-weight: 700;
//           letter-spacing: .5px; text-transform: uppercase;
//           padding: 4px 12px; border-radius: 999px; margin-bottom: 20px;
//         }
//         .hps-save-feat { background: rgba(201,168,76,.18) !important; border-color: rgba(201,168,76,.42) !important; }

//         /* divider */
//         .hps-hdiv {
//           height: 1px;
//           background: linear-gradient(90deg,rgba(255,255,255,.05),rgba(201,168,76,.1),rgba(255,255,255,.05));
//           margin-bottom: 16px;
//         }
//         .hps-hdiv-feat { background: linear-gradient(90deg,transparent,rgba(201,168,76,.38),transparent) !important; }

//         /* features */
//         .hps-feats { margin-bottom: 4px; }
//         .hps-frow {
//           display: flex; align-items: center; gap: 10px;
//           padding: 7px 0; border-bottom: 1px solid rgba(255,255,255,.04);
//           font-size: 12.5px; font-family: 'DM Sans', sans-serif;
//         }
//         .hps-fy { color: rgba(255,255,255,.82); }
//         .hps-fn { color: rgba(255,255,255,.22); }
//         .hps-fn .hps-fl { text-decoration: line-through; }
//         .hps-dy {
//           width: 18px; height: 18px; border-radius: 50%; flex-shrink: 0;
//           background: linear-gradient(135deg,rgba(201,168,76,.2),rgba(201,168,76,.05));
//           border: 1px solid rgba(201,168,76,.36);
//           display: flex; align-items: center; justify-content: center;
//           font-size: 9px; font-weight: 800; color: #C9A84C;
//         }
//         .hps-dn {
//           width: 18px; height: 18px; border-radius: 50%; flex-shrink: 0;
//           background: rgba(255,255,255,.03); border: 1px solid rgba(255,255,255,.07);
//           display: flex; align-items: center; justify-content: center;
//           font-size: 13px; color: rgba(255,255,255,.15);
//         }

//         /* expand button */
//         .hps-expand {
//           background: none; border: none; color: rgba(201,168,76,.5);
//           font-size: 11px; font-weight: 500; cursor: pointer;
//           padding: 10px 0 4px; font-family: 'DM Sans', sans-serif;
//           letter-spacing: .3px; display: flex; align-items: center; gap: 5px;
//           transition: color .2s;
//         }
//         .hps-expand:hover { color: #C9A84C; }

//         /* cta area */
//         .hps-cta { padding: 0 28px 28px; }
//         .hps-card-feat .hps-cta { padding: 0 32px 32px; }

//         /* buttons */
//         .hps-btn {
//           width: 100%; border: none; border-radius: 14px;
//           font-family: 'DM Sans', sans-serif; font-weight: 600; font-size: 13.5px;
//           cursor: pointer; padding: 14px;
//           display: flex; align-items: center; justify-content: center; gap: 8px;
//           transition: transform .25s, box-shadow .25s;
//           position: relative; overflow: hidden; letter-spacing: .3px;
//         }
//         .hps-btn-gold {
//           background: linear-gradient(135deg,#B8860B 0%,#C9A84C 28%,#F5D87A 52%,#C9A84C 74%,#9A6E10 100%);
//           background-size: 200% 200%; animation: hps-gold 3s ease infinite;
//           color: #0D0020 !important;
//           box-shadow: 0 6px 28px rgba(201,168,76,.45), inset 0 1px 0 rgba(255,255,255,.3);
//         }
//         .hps-btn-gold:hover { transform: translateY(-2px); box-shadow: 0 12px 40px rgba(201,168,76,.62); }
//         .hps-btn-outline {
//           background: transparent !important;
//           border: 1px solid rgba(255,255,255,.12) !important;
//           color: rgba(255,255,255,.52) !important;
//         }
//         .hps-btn-outline:hover {
//           background: rgba(255,255,255,.06) !important;
//           color: rgba(255,255,255,.82) !important;
//           border-color: rgba(255,255,255,.22) !important;
//         }

//         /* shine sweep on gold btn */
//         .hps-shine {
//           position: absolute; top: 0; left: -80%; width: 55%; height: 100%;
//           background: linear-gradient(120deg,transparent,rgba(255,255,255,.5),transparent);
//           transform: skewX(-20deg); animation: hps-shine 2.8s ease infinite;
//         }
//         @keyframes hps-shine {
//           0%        { left: -80%; opacity: 0; }
//           8%        { opacity: 1; }
//           48%       { left: 130%; opacity: 1; }
//           49%, 100% { left: 130%; opacity: 0; }
//         }

//         /* dots */
//         .hps-dots { display: flex; justify-content: center; gap: 8px; margin-top: 28px; }
//         .hps-pip {
//           border: none; cursor: pointer; height: 2px; border-radius: 999px;
//           background: rgba(255,255,255,.12); transition: all .3s; padding: 0;
//         }
//         .hps-pip-on { background: linear-gradient(90deg,#C9A84C,#F5D87A) !important; }

//         /* mobile */
//         .hps-mob { overflow: hidden; padding: 16px 0 20px; position: relative; z-index: 2; }
//         .hps-mob-track {
//           display: flex; align-items: flex-start;
//           transition: transform .46s cubic-bezier(.34,1.26,.64,1); will-change: transform;
//         }
//         .hps-mob-slide { flex-shrink: 0; transition: transform .44s, opacity .44s, filter .44s; }
//         .hps-mc { transform: scale(1) !important; opacity: 1 !important; filter: none !important; }
//         .hps-ms { transform: scale(0.87) translateY(14px) !important; opacity: .45 !important; filter: saturate(.5) !important; }

//         /* mobile nav */
//         .hps-mob-nav { display: flex; justify-content: center; gap: 10px; margin-top: 16px; }
//         .hps-nav-p, .hps-nav-n {
//           border-radius: 12px; padding: 9px 24px; font-weight: 600; font-size: 13px;
//           cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all .2s; border: none;
//         }
//         .hps-nav-p {
//           background: rgba(255,255,255,.07); border: 1px solid rgba(255,255,255,.12);
//           color: rgba(255,255,255,.52);
//         }
//         .hps-nav-p:hover:not(:disabled) { background: rgba(255,255,255,.11); color: rgba(255,255,255,.82); }
//         .hps-nav-n {
//           background: linear-gradient(135deg,#B8860B,#C9A84C);
//           color: #0D0020; box-shadow: 0 4px 14px rgba(201,168,76,.35);
//         }
//         .hps-nav-n:hover:not(:disabled) { box-shadow: 0 6px 20px rgba(201,168,76,.52); }
//         .hps-nav-p:disabled, .hps-nav-n:disabled { opacity: .25; cursor: not-allowed; }

//         /* whatsapp */
//         .hps-wa {
//           display: inline-flex; align-items: center; gap: 9px;
//           padding: 14px 32px; border-radius: 50px;
//           background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.1);
//           color: rgba(255,255,255,.65); font-family: 'DM Sans', sans-serif;
//           font-weight: 600; font-size: 14px; text-decoration: none;
//           transition: all .25s; backdrop-filter: blur(8px);
//         }
//         .hps-wa:hover { background: rgba(37,211,102,.15); border-color: rgba(37,211,102,.3); color: #fff; }

//         /* responsive */
//         @media(max-width: 900px) {
//           .hps-grid { grid-template-columns: 1fr; gap: 16px; max-width: 440px; margin: 0 auto; }
//           .hps-card:first-child,
//           .hps-card:last-child {
//             border-radius: 20px !important;
//             border: 1px solid rgba(255,255,255,.09) !important;
//           }
//           .hps-card-feat { border-radius: 20px !important; }
//           .hps-card-feat.hps-visible { transform: translateY(0) !important; }
//           .hps-card-feat:hover        { transform: translateY(-8px) !important; }
//         }

//         /* bootstrap grid helpers scoped */
//         @media(max-width: 767px) {
//           .hps-sec .d-md-none  { display: block !important; }
//           .hps-sec .d-none     { display: none !important; }
//           .hps-sec .d-md-grid  { display: none !important; }
//           .hps-sec .d-md-flex  { display: none !important; }
//         }
//         @media(min-width: 768px) {
//           .hps-sec .d-md-none  { display: none !important; }
//           .hps-sec .d-none     { display: block !important; }
//           .hps-sec .d-md-grid  { display: grid !important; }
//           .hps-sec .d-md-flex  { display: flex !important; }
//         }
//       `}</style>
//     </section>
//   );
// }

// /* ── Floating particles ─────────────────────────────────────────── */
// function HpsParticles() {
//   useEffect(() => {
//     const wrap = document.querySelector(".hps-particles");
//     if (!wrap || wrap.childElementCount > 0) return;
//     const POS = [[8,18],[18,78],[32,12],[48,88],[62,8],[72,68],[82,32],[88,58],[42,42],[14,52],[55,28],[68,82]];
//     POS.forEach(([l, t]) => {
//       const p = document.createElement("div");
//       p.className = "hps-p";
//       const s = 1 + Math.random() * 2;
//       p.style.cssText = `left:${l}%;top:${t}%;width:${s}px;height:${s}px;animation-duration:${4+Math.random()*6}s;animation-delay:${Math.random()*5}s;`;
//       wrap.appendChild(p);
//     });
//   }, []);
//   return <div className="hps-particles" />;
// }

// /* ── Entrance observer ──────────────────────────────────────────── */
// function HpsEntranceObserver() {
//   useEffect(() => {
//     const cards = document.querySelectorAll(".hps-card");
//     const obs = new IntersectionObserver(
//       entries => {
//         entries.forEach((e, i) => {
//           if (e.isIntersecting) {
//             setTimeout(() => e.target.classList.add("hps-visible"), i * 140);
//             obs.unobserve(e.target);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );
//     cards.forEach(c => obs.observe(c));
//     return () => obs.disconnect();
//   }, []);
//   return null;
// }

// export default HomePackagesSection;
import { useRef, useState, useEffect } from "react";

const PLANS = [
  {
    id: 0, tier: "01", title: "Standard",
    tagline: "Includes cake, lights & decor. A warm, intimate celebration.",
    save: "💰 Save ₹200", featured: false,
    features: [
      { label: "Theatre + Decoration",      yes: true  },
      { label: "Fog Entry (1 Pot)",          yes: true  },
      { label: "Candle Path",                yes: true  },
      { label: "HBD LED + Name LED (6)",     yes: true  },
      { label: "AGE Number LED",             yes: true  },
      { label: "HBD with Rose Petals",       yes: true  },
      { label: "Photo Clipping (10)",        yes: true  },
      { label: "Birthday Sash",              yes: true  },
      { label: "Birthday Crown & Specs",     yes: true  },
      { label: "Rose",                       yes: true  },
      { label: "Regular Cake – ½ kg",        yes: true  },
      { label: "Photography (15 Mins)",      yes: true  },
      { label: "Cold Fire Entry",            yes: false },
      { label: "Videography (1-Min Reel)",   yes: false },
      { label: "Hall Fog (4 Pots)",          yes: false },
    ],
  },
  {
    id: 1, tier: "02", title: "Special",
    tagline: "Royal vibes — custom cake, cold fire & extended photography.",
    save: "⭐ Guests' Favourite", featured: true,
    features: [
      { label: "Theatre + Decoration",      yes: true  },
      { label: "Fog Entry (1 Pot)",          yes: true  },
      { label: "Candle Path",                yes: true  },
      { label: "HBD LED + Name LED (6)",     yes: true  },
      { label: "AGE Number LED",             yes: true  },
      { label: "HBD with Rose Petals",       yes: true  },
      { label: "Photo Clipping (10)",        yes: true  },
      { label: "Birthday Sash + Crown",      yes: true  },
      { label: "Rose Bouquet (6 Roses)",     yes: true  },
      { label: "Customisation Cake (1 kg)",  yes: true  },
      { label: "Photography (30 Mins)",      yes: true  },
      { label: "Cold Fire Entry (4 pcs)",    yes: true  },
      { label: "Videography (1-Min Reel)",   yes: false },
      { label: "Hall Fog (4 Pots)",          yes: false },
    ],
  },
  {
    id: 2, tier: "03", title: "Premium",
    tagline: "The complete experience — everything included, zero compromises.",
    save: "🎁 Save ₹300", featured: false,
    features: [
      { label: "Theatre + Decoration",      yes: true },
      { label: "Fog Entry + Hall Fog",       yes: true },
      { label: "Candle Path",                yes: true },
      { label: "HBD LED + Name LED (6)",     yes: true },
      { label: "AGE Number LED",             yes: true },
      { label: "HBD with Rose Petals",       yes: true },
      { label: "Photo Clipping (10)",        yes: true },
      { label: "Birthday Sash + Crown",      yes: true },
      { label: "Rose Bouquet (12 Roses)",    yes: true },
      { label: "Customisation Cake (1 kg)",  yes: true },
      { label: "Photography (30 Mins)",      yes: true },
      { label: "Cold Fire Entry (6 pcs)",    yes: true },
      { label: "Videography (1-Min Reel)",   yes: true },
      { label: "Hall Fog (4 Pots)",          yes: true },
    ],
  },
];

const PREVIEW = 7;

/* ─── Card receives shared expanded state ─── */
function HpsPlanCard({ plan, onBook, expanded, onToggleExpanded }) {
  const shown = expanded ? plan.features : plan.features.slice(0, PREVIEW);

  return (
    <div className={`hps-card${plan.featured ? " hps-card-feat" : ""}`}>
      {plan.featured && <div className="hps-topline" />}
      {plan.featured && <div className="hps-crown">✦ Most Popular ✦</div>}

      <div className="hps-inner">
        <div className="hps-tier">{plan.tier} &nbsp; {plan.title}</div>
        <div className={`hps-name${plan.featured ? " hps-name-feat" : ""}`}>{plan.title}</div>
        <p className="hps-tagline">{plan.tagline}</p>
        <div className={`hps-save${plan.featured ? " hps-save-feat" : ""}`}>{plan.save}</div>
        <div className={`hps-hdiv${plan.featured ? " hps-hdiv-feat" : ""}`} />

        <div className="hps-feats">
          {shown.map((f, i) => (
            <div key={i} className={`hps-frow${f.yes ? " hps-fy" : " hps-fn"}`}>
              <div className={f.yes ? "hps-dy" : "hps-dn"}>{f.yes ? "✓" : "—"}</div>
              <span className="hps-fl">{f.label}</span>
            </div>
          ))}
        </div>

        {/* single toggle button — clicking it toggles ALL cards at once */}
        <button
          className="hps-expand"
          style={plan.featured ? { color: "rgba(201,168,76,.65)" } : {}}
          onClick={onToggleExpanded}
        >
          {expanded ? "▴ Show less" : "▾ All inclusions"}
        </button>
      </div>

      <div className="hps-cta">
        <button
          className={`hps-btn${plan.featured ? " hps-btn-gold" : " hps-btn-outline"}`}
          onClick={onBook}
        >
          {plan.featured && <span className="hps-shine" />}
          {plan.featured ? "Book This Plan →" : "Proceed to Book →"}
        </button>
      </div>
    </div>
  );
}

function HomePackagesSection({ navigateTheater }) {
  const [active,   setActive]   = useState(1);
  /* ── single shared expanded state ── */
  const [expanded, setExpanded] = useState(false);

  const touchStartX = useRef(null);
  const touchStartY = useRef(null);
  const isSwiping   = useRef(false);

  const onTouchStart = e => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
    isSwiping.current   = false;
  };
  const onTouchMove = e => {
    if (!touchStartX.current) return;
    const dx = Math.abs(e.touches[0].clientX - touchStartX.current);
    const dy = Math.abs(e.touches[0].clientY - touchStartY.current);
    if (dx > dy && dx > 8) { isSwiping.current = true; e.preventDefault(); }
  };
  const onTouchEnd = e => {
    if (!touchStartX.current) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (isSwiping.current && Math.abs(dx) > 40)
      setActive(p => dx < 0 ? Math.min(PLANS.length - 1, p + 1) : Math.max(0, p - 1));
    touchStartX.current = null;
    isSwiping.current   = false;
  };

  const CARD_VW = 78, GAP_VW = 4;
  const mobX = `calc(${50 - CARD_VW / 2}vw - ${active * (CARD_VW + GAP_VW)}vw)`;

  const HpsDots = () => (
    <div className="hps-dots">
      {PLANS.map((_, i) => (
        <button
          key={i}
          className={`hps-pip${i === active ? " hps-pip-on" : ""}`}
          style={{ width: i === active ? 28 : 8 }}
          onClick={() => setActive(i)}
        />
      ))}
    </div>
  );

  return (
    <section className="hps-sec">
      <div className="hps-noise" />
      <HpsParticles />

      <div className="container">
        <div className="hps-hdr rv">
          <div className="hps-pre">Celebration Packages</div>
          <h2 className="hps-title">Choose Your <em>Plans</em></h2>
          <p className="hps-subtitle">
            Every package includes full private theatre access — crafted for unforgettable moments
          </p>
        </div>

        {/* desktop */}
        <div className="hps-grid d-none d-md-grid rv">
          {PLANS.map(p => (
            <HpsPlanCard
              key={p.id}
              plan={p}
              onBook={() => navigateTheater("/locations")}
              expanded={expanded}
              onToggleExpanded={() => setExpanded(e => !e)}
            />
          ))}
        </div>
        <div className="d-none d-md-flex" style={{ justifyContent: "center" }}>
          <HpsDots />
        </div>

        {/* mobile */}
        <div
          className="hps-mob d-md-none"
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          <div className="hps-mob-track" style={{ transform: `translateX(${mobX})` }}>
            {PLANS.map((p, i) => (
              <div
                key={p.id}
                className={`hps-mob-slide${i === active ? " hps-mc" : " hps-ms"}`}
                style={{ width: `${CARD_VW}vw`, marginLeft: i === 0 ? 0 : `${GAP_VW}vw` }}
                onClick={() => { if (!isSwiping.current) setActive(i); }}
              >
                <HpsPlanCard
                  plan={p}
                  onBook={() => navigateTheater("/locations")}
                  expanded={expanded}
                  onToggleExpanded={() => setExpanded(e => !e)}
                />
              </div>
            ))}
          </div>
          <HpsDots />
          <div className="hps-mob-nav">
            <button className="hps-nav-p" disabled={active === 0} onClick={() => setActive(p => p - 1)}>← Prev</button>
            <button className="hps-nav-n" disabled={active === PLANS.length - 1} onClick={() => setActive(p => p + 1)}>Next →</button>
          </div>
        </div>

        {/* whatsapp */}
        <div style={{ textAlign: "center", marginTop: 32, position: "relative", zIndex: 2 }}>
          <a
            href="https://wa.me/918374777834?text=Hello%2C%20I%20want%20to%20book%20tickets."
            target="_blank" rel="noopener noreferrer"
            className="hps-wa"
          >
            <i className="bi bi-whatsapp" /> Chat With Us
          </a>
        </div>
      </div>

      <HpsEntranceObserver />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,600;0,700;1,600&family=DM+Sans:wght@300;400;500;600&display=swap');

        .hps-sec {
          padding: 96px 0 80px;
          background: linear-gradient(170deg,#0D0020 0%,#180038 35%,#2A0055 65%,#0D0020 100%);
          position: relative; overflow: hidden;
        }
        .hps-sec::before {
          content: ''; position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 800px 600px at 15% 20%,rgba(201,168,76,.05) 0%,transparent 60%),
            radial-gradient(ellipse 600px 500px at 85% 80%,rgba(157,77,255,.08) 0%,transparent 60%);
          pointer-events: none;
        }
        .hps-noise {
          position: absolute; inset: 0; opacity: .02;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
          pointer-events: none; z-index: 0;
        }
        .hps-particles { position: absolute; inset: 0; pointer-events: none; overflow: hidden; z-index: 1; }
        .hps-p {
          position: absolute; border-radius: 50%; background: #C9A84C;
          animation: hps-float linear infinite; opacity: 0;
        }
        @keyframes hps-float {
          0%   { transform: translateY(0) scale(0);       opacity: 0; }
          10%  { opacity: .55; }
          90%  { opacity: .25; }
          100% { transform: translateY(-110px) scale(.4); opacity: 0; }
        }

        .hps-hdr { text-align: center; margin-bottom: 72px; position: relative; z-index: 2; }
        .hps-pre {
          display: inline-flex; align-items: center; gap: 10px;
          font-size: 10px; font-weight: 600; letter-spacing: 4px; text-transform: uppercase;
          color: #C9A84C; margin-bottom: 20px;
        }
        .hps-pre::before, .hps-pre::after {
          content: ''; width: 32px; height: 1px;
          background: linear-gradient(90deg, transparent, #C9A84C);
        }
        .hps-pre::after { background: linear-gradient(90deg, #C9A84C, transparent); }
        .hps-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(40px,6vw,68px); font-weight: 600;
          color: #fff; line-height: 1.05; margin-bottom: 14px; letter-spacing: -.5px;
        }
        .hps-title em { font-style: italic; color: #C9A84C; }
        .hps-subtitle { color: rgba(255,255,255,.38); font-size: 15px; font-weight: 300; }

        .hps-grid {
          display: grid;
          grid-template-columns: 1fr 1.08fr 1fr;
          gap: 0; position: relative; z-index: 2;
          align-items: end; margin-bottom: 8px;
        }

        .hps-card {
          position: relative;
          background: linear-gradient(170deg,rgba(255,255,255,.045) 0%,rgba(255,255,255,.018) 100%);
          border: 1px solid rgba(255,255,255,.09);
          display: flex; flex-direction: column;
          transition: transform .5s cubic-bezier(.25,1,.5,1), box-shadow .5s, opacity .7s;
          cursor: pointer; overflow: hidden;
          opacity: 0; transform: translateY(28px);
        }
        .hps-card.hps-visible { opacity: 1 !important; transform: translateY(0) !important; }
        .hps-card:first-child { border-radius: 24px 0 0 24px; border-right: none; }
        .hps-card:last-child  { border-radius: 0 24px 24px 0; border-left: none; }
        .hps-card:hover { transform: translateY(-8px) !important; z-index: 3; }
        .hps-card::before {
          content: ''; position: absolute; inset: 0;
          background: linear-gradient(170deg,rgba(201,168,76,.04) 0%,transparent 60%);
          opacity: 0; transition: opacity .4s; pointer-events: none;
        }
        .hps-card:hover::before { opacity: 1; }

        .hps-card-feat {
          background: linear-gradient(170deg,rgba(201,168,76,.1) 0%,rgba(157,77,255,.06) 50%,rgba(201,168,76,.04) 100%) !important;
          border: 1px solid rgba(201,168,76,.32) !important;
          border-radius: 24px !important;
          box-shadow:
            0 0 0 1px rgba(201,168,76,.15),
            0 32px 80px rgba(0,0,0,.6),
            0 0 100px rgba(201,168,76,.07),
            inset 0 1px 0 rgba(201,168,76,.2) !important;
          z-index: 4;
        }
        .hps-card-feat.hps-visible { transform: translateY(-20px) scale(1.01) !important; }
        .hps-card-feat:hover        { transform: translateY(-28px) scale(1.01) !important; }

        .hps-topline {
          position: absolute; top: 0; left: 0; right: 0; height: 2px;
          background: linear-gradient(90deg,transparent,#C9A84C 30%,#F5D87A 50%,#C9A84C 70%,transparent);
          animation: hps-topline 3s ease infinite; z-index: 5;
        }
        @keyframes hps-topline { 0%,100%{opacity:.65;} 50%{opacity:1;} }

        .hps-crown {
          position: absolute; top: -16px; left: 50%; transform: translateX(-50%);
          background: linear-gradient(135deg,#B8860B,#C9A84C,#F5D87A,#C9A84C,#9A6E10);
          background-size: 200% 200%;
          animation: hps-gold 3s ease infinite;
          color: #0D0020; font-size: 9px; font-weight: 800;
          letter-spacing: 2px; text-transform: uppercase;
          padding: 6px 20px; border-radius: 999px; white-space: nowrap; z-index: 10;
          box-shadow: 0 4px 20px rgba(201,168,76,.5), 0 0 36px rgba(201,168,76,.12);
        }
        @keyframes hps-gold {
          0%  { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100%{ background-position: 0% 50%; }
        }

        .hps-inner { padding: 36px 28px 20px; }
        .hps-card-feat .hps-inner { padding: 44px 32px 20px; }

        .hps-tier {
          font-family: 'Cormorant Garamond', serif;
          font-size: 11px; font-weight: 600; letter-spacing: 4px; text-transform: uppercase;
          color: rgba(201,168,76,.45); margin-bottom: 14px;
          display: flex; align-items: center; gap: 8px;
        }
        .hps-tier::after { content: ''; flex: 1; height: 1px; background: linear-gradient(90deg,rgba(201,168,76,.15),transparent); }
        .hps-card-feat .hps-tier { color: rgba(201,168,76,.72); }

        .hps-name {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(28px,3.5vw,42px); font-weight: 600;
          color: #fff; line-height: 1; margin-bottom: 6px;
        }
        .hps-name-feat { color: #F5D87A !important; }

        .hps-tagline { font-size: 12px; color: rgba(255,255,255,.32); line-height: 1.6; margin-bottom: 18px; font-weight: 300; }

        .hps-save {
          display: inline-flex; align-items: center; gap: 5px;
          background: rgba(201,168,76,.09); border: 1px solid rgba(201,168,76,.2);
          color: #C9A84C; font-size: 10px; font-weight: 700;
          letter-spacing: .5px; text-transform: uppercase;
          padding: 4px 12px; border-radius: 999px; margin-bottom: 20px;
        }
        .hps-save-feat { background: rgba(201,168,76,.18) !important; border-color: rgba(201,168,76,.42) !important; }

        .hps-hdiv {
          height: 1px;
          background: linear-gradient(90deg,rgba(255,255,255,.05),rgba(201,168,76,.1),rgba(255,255,255,.05));
          margin-bottom: 16px;
        }
        .hps-hdiv-feat { background: linear-gradient(90deg,transparent,rgba(201,168,76,.38),transparent) !important; }

        .hps-feats { margin-bottom: 4px; }
        .hps-frow {
          display: flex; align-items: center; gap: 10px;
          padding: 7px 0; border-bottom: 1px solid rgba(255,255,255,.04);
          font-size: 12.5px; font-family: 'DM Sans', sans-serif;
        }
        .hps-fy { color: rgba(255,255,255,.82); }
        .hps-fn { color: rgba(255,255,255,.22); }
        .hps-fn .hps-fl { text-decoration: line-through; }
        .hps-dy {
          width: 18px; height: 18px; border-radius: 50%; flex-shrink: 0;
          background: linear-gradient(135deg,rgba(201,168,76,.2),rgba(201,168,76,.05));
          border: 1px solid rgba(201,168,76,.36);
          display: flex; align-items: center; justify-content: center;
          font-size: 9px; font-weight: 800; color: #C9A84C;
        }
        .hps-dn {
          width: 18px; height: 18px; border-radius: 50%; flex-shrink: 0;
          background: rgba(255,255,255,.03); border: 1px solid rgba(255,255,255,.07);
          display: flex; align-items: center; justify-content: center;
          font-size: 13px; color: rgba(255,255,255,.15);
        }

        /* ── expand button — same label, same action across all cards ── */
        .hps-expand {
          background: none; border: none; color: rgba(201,168,76,.5);
          font-size: 11px; font-weight: 500; cursor: pointer;
          padding: 10px 0 4px; font-family: 'DM Sans', sans-serif;
          letter-spacing: .3px; display: flex; align-items: center; gap: 5px;
          transition: color .2s;
        }
        .hps-expand:hover { color: #C9A84C; }

        .hps-cta { padding: 0 28px 28px; }
        .hps-card-feat .hps-cta { padding: 0 32px 32px; }

        .hps-btn {
          width: 100%; border: none; border-radius: 14px;
          font-family: 'DM Sans', sans-serif; font-weight: 600; font-size: 13.5px;
          cursor: pointer; padding: 14px;
          display: flex; align-items: center; justify-content: center; gap: 8px;
          transition: transform .25s, box-shadow .25s;
          position: relative; overflow: hidden; letter-spacing: .3px;
        }
        .hps-btn-gold {
          background: linear-gradient(135deg,#B8860B 0%,#C9A84C 28%,#F5D87A 52%,#C9A84C 74%,#9A6E10 100%);
          background-size: 200% 200%; animation: hps-gold 3s ease infinite;
          color: #0D0020 !important;
          box-shadow: 0 6px 28px rgba(201,168,76,.45), inset 0 1px 0 rgba(255,255,255,.3);
        }
        .hps-btn-gold:hover { transform: translateY(-2px); box-shadow: 0 12px 40px rgba(201,168,76,.62); }
        .hps-btn-outline {
          background: transparent !important;
          border: 1px solid rgba(255,255,255,.12) !important;
          color: rgba(255,255,255,.52) !important;
        }
        .hps-btn-outline:hover {
          background: rgba(255,255,255,.06) !important;
          color: rgba(255,255,255,.82) !important;
          border-color: rgba(255,255,255,.22) !important;
        }

        .hps-shine {
          position: absolute; top: 0; left: -80%; width: 55%; height: 100%;
          background: linear-gradient(120deg,transparent,rgba(255,255,255,.5),transparent);
          transform: skewX(-20deg); animation: hps-shine 2.8s ease infinite;
        }
        @keyframes hps-shine {
          0%        { left: -80%; opacity: 0; }
          8%        { opacity: 1; }
          48%       { left: 130%; opacity: 1; }
          49%, 100% { left: 130%; opacity: 0; }
        }

        .hps-dots { display: flex; justify-content: center; gap: 8px; margin-top: 28px; }
        .hps-pip {
          border: none; cursor: pointer; height: 2px; border-radius: 999px;
          background: rgba(255,255,255,.12); transition: all .3s; padding: 0;
        }
        .hps-pip-on { background: linear-gradient(90deg,#C9A84C,#F5D87A) !important; }

        .hps-mob { overflow: hidden; padding: 16px 0 20px; position: relative; z-index: 2; }
        .hps-mob-track {
          display: flex; align-items: flex-start;
          transition: transform .46s cubic-bezier(.34,1.26,.64,1); will-change: transform;
        }
        .hps-mob-slide { flex-shrink: 0; transition: transform .44s, opacity .44s, filter .44s; }
        .hps-mc { transform: scale(1) !important; opacity: 1 !important; filter: none !important; }
        .hps-ms { transform: scale(0.87) translateY(14px) !important; opacity: .45 !important; filter: saturate(.5) !important; }

        .hps-mob-nav { display: flex; justify-content: center; gap: 10px; margin-top: 16px; }
        .hps-nav-p, .hps-nav-n {
          border-radius: 12px; padding: 9px 24px; font-weight: 600; font-size: 13px;
          cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all .2s; border: none;
        }
        .hps-nav-p {
          background: rgba(255,255,255,.07); border: 1px solid rgba(255,255,255,.12);
          color: rgba(255,255,255,.52);
        }
        .hps-nav-p:hover:not(:disabled) { background: rgba(255,255,255,.11); color: rgba(255,255,255,.82); }
        .hps-nav-n {
          background: linear-gradient(135deg,#B8860B,#C9A84C);
          color: #0D0020; box-shadow: 0 4px 14px rgba(201,168,76,.35);
        }
        .hps-nav-n:hover:not(:disabled) { box-shadow: 0 6px 20px rgba(201,168,76,.52); }
        .hps-nav-p:disabled, .hps-nav-n:disabled { opacity: .25; cursor: not-allowed; }

        .hps-wa {
          display: inline-flex; align-items: center; gap: 9px;
          padding: 14px 32px; border-radius: 50px;
          background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.1);
          color: rgba(255,255,255,.65); font-family: 'DM Sans', sans-serif;
          font-weight: 600; font-size: 14px; text-decoration: none;
          transition: all .25s; backdrop-filter: blur(8px);
        }
        .hps-wa:hover { background: rgba(37,211,102,.15); border-color: rgba(37,211,102,.3); color: #fff; }

        @media(max-width: 900px) {
          .hps-grid { grid-template-columns: 1fr; gap: 16px; max-width: 440px; margin: 0 auto; }
          .hps-card:first-child,
          .hps-card:last-child {
            border-radius: 20px !important;
            border: 1px solid rgba(255,255,255,.09) !important;
          }
          .hps-card-feat { border-radius: 20px !important; }
          .hps-card-feat.hps-visible { transform: translateY(0) !important; }
          .hps-card-feat:hover        { transform: translateY(-8px) !important; }
        }

        @media(max-width: 767px) {
          .hps-sec .d-md-none  { display: block !important; }
          .hps-sec .d-none     { display: none !important; }
          .hps-sec .d-md-grid  { display: none !important; }
          .hps-sec .d-md-flex  { display: none !important; }
        }
        @media(min-width: 768px) {
          .hps-sec .d-md-none  { display: none !important; }
          .hps-sec .d-none     { display: block !important; }
          .hps-sec .d-md-grid  { display: grid !important; }
          .hps-sec .d-md-flex  { display: flex !important; }
        }
      `}</style>
    </section>
  );
}

function HpsParticles() {
  useEffect(() => {
    const wrap = document.querySelector(".hps-particles");
    if (!wrap || wrap.childElementCount > 0) return;
    const POS = [[8,18],[18,78],[32,12],[48,88],[62,8],[72,68],[82,32],[88,58],[42,42],[14,52],[55,28],[68,82]];
    POS.forEach(([l, t]) => {
      const p = document.createElement("div");
      p.className = "hps-p";
      const s = 1 + Math.random() * 2;
      p.style.cssText = `left:${l}%;top:${t}%;width:${s}px;height:${s}px;animation-duration:${4+Math.random()*6}s;animation-delay:${Math.random()*5}s;`;
      wrap.appendChild(p);
    });
  }, []);
  return <div className="hps-particles" />;
}

function HpsEntranceObserver() {
  useEffect(() => {
    const cards = document.querySelectorAll(".hps-card");
    const obs = new IntersectionObserver(
      entries => {
        entries.forEach((e, i) => {
          if (e.isIntersecting) {
            setTimeout(() => e.target.classList.add("hps-visible"), i * 140);
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    cards.forEach(c => obs.observe(c));
    return () => obs.disconnect();
  }, []);
  return null;
}

export default HomePackagesSection;